// frontend-web/src/pages/Admin/EditMegaScholarship.jsx

import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate, useParams } from "react-router-dom";

export default function EditMegaScholarship() {
  const [loading, setLoading] = useState(true);
  const [exam, setExam] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [selected, setSelected] = useState([]);

  const [form, setForm] = useState({
    title: "",
    total_marks: 0,
    duration: 0,
    entry_fee: 0,
  });

  const { id } = useParams();
  const nav = useNavigate();

  useEffect(() => {
    loadExam();
  }, [id]);

  const loadExam = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/admin/mega_scholarship/${id}`);
      const data = res.data;

      setExam(data);
      setForm({
        title: data.title,
        total_marks: data.total_questions,
        duration: data.duration_minutes,
        entry_fee: data.entry_fee,
      });

      // Auto-select already assigned questions
      setSelected(data.assigned_questions.map(q => q.id));

      // Load questions
      const subjects = Array.isArray(data.subject_ids) ? data.subject_ids.join(",") : data.subject_ids;
      const qRes = await api.get(`/admin/questions?class_id=${data.class_id}&subject_ids=${subjects}`);

      setQuestions(qRes.data.questions || []);

    } catch (err) {
      alert("Failed to load exam");
      nav("/admin/mega-scholarship-list");
    } finally {
      setLoading(false);
    }
  };

  const toggleQuestion = (qid) => {
    setSelected(prev =>
      prev.includes(qid) ? prev.filter(id => id !== qid) : [...prev, qid]
    );
  };

  const handleSubmit = async () => {
    if (selected.length !== form.total_marks) {
      alert(`Please select exactly ${form.total_marks} questions. Selected: ${selected.length}`);
      return;
    }

    try {
      await api.put(`/admin/mega_scholarship/${id}`, {
        title: form.title.trim(),
        duration: Number(form.duration),
        total_marks: Number(form.total_marks),
        entry_fee: Number(form.entry_fee),
        question_ids: selected
      });

      alert("Mega Scholarship Exam Updated Successfully!");
      nav("/admin/mega-scholarship-list");

    } catch (err) {
      alert(err.response?.data?.error || "Update Failed");
    }
  };

  if (loading) {
    return <div style={{ padding: 60, fontSize: 20 }}>Loading...</div>;
  }

  return (
    <div style={{ padding: 30 }}>
      <h2>Edit Mega Scholarship Exam #{id}</h2>

      <div style={{ background: "#fff", padding: 20, borderRadius: 10, marginBottom: 20 }}>
        
        <label>Title</label>
        <input
          value={form.title}
          onChange={e => setForm({ ...form, title: e.target.value })}
          style={inputStyle}
        />

        <label>Total Questions</label>
        <input
          type="number"
          value={form.total_marks}
          onChange={e => setForm({ ...form, total_marks: Number(e.target.value) })}
          style={inputStyle}
        />

        <label>Duration (Minutes)</label>
        <input
          type="number"
          value={form.duration}
          onChange={e => setForm({ ...form, duration: Number(e.target.value) })}
          style={inputStyle}
        />

        <label>Entry Fee (₹)</label>
        <input
          type="number"
          value={form.entry_fee}
          onChange={e => setForm({ ...form, entry_fee: Number(e.target.value) })}
          style={inputStyle}
        />
      </div>

      {/* Question List */}
      <div style={{ background: "#fff", padding: 20, borderRadius: 10 }}>
        <h3>Select Questions ({selected.length}/{form.total_marks})</h3>

        {questions.map((q, idx) => (
          <label key={q.id} style={boxStyle(selected.includes(q.id))}>
            <input type="checkbox" checked={selected.includes(q.id)} onChange={() => toggleQuestion(q.id)} />
            <span style={{ marginLeft: 10 }}>
              <strong>Q{idx + 1}:</strong> {q.text}
            </span>
          </label>
        ))}

        <button
          onClick={handleSubmit}
          disabled={selected.length !== form.total_marks}
          style={{
            marginTop: 20,
            padding: "12px 24px",
            background: selected.length === form.total_marks ? "green" : "#999",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            cursor: selected.length === form.total_marks ? "pointer" : "not-allowed"
          }}
        >
          Save Changes
        </button>
      </div>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: "10px",
  marginBottom: 15,
  borderRadius: 8,
  border: "1px solid #ccc"
};

const boxStyle = (active) => ({
  display: "flex",
  padding: "12px",
  border: `2px solid ${active ? "blue" : "#ddd"}`,
  borderRadius: 8,
  marginTop: 10,
  cursor: "pointer"
});
